(function() {
  const TRUSTPILOT_SCRIPT_URL = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';

  const placeholder = document.getElementById('trustpilot-consent-placeholder');
  const placeholderContent = document.getElementById('trustpilot-consent-content');
  const widgetWrapper = document.getElementById('trustpilot-widget-wrapper');
  const acceptBtn = document.getElementById('trustpilot-consent-accept');
  let widgetLoaded = false;

  function showPlaceholderContent() {
    if (placeholder) placeholder.classList.remove('animate-shimmer');
    if (placeholderContent) placeholderContent.style.visibility = 'visible';
    if (acceptBtn) acceptBtn.style.visibility = 'visible';
  }

  // Trustpilot-Widgets rendern. Beim dynamischen Nachladen des Bootstrap-Scripts
  // (nach DOMContentLoaded) scannt Trustpilot die .trustpilot-widget-Container
  // nicht automatisch — deshalb pro Widget explizit loadFromElement aufrufen.
  function renderWidgets() {
    if (!window.Trustpilot || typeof window.Trustpilot.loadFromElement !== 'function') return;
    document.querySelectorAll('.trustpilot-widget').forEach(function(el) {
      window.Trustpilot.loadFromElement(el, true);
    });
  }

  function loadTrustpilot() {
    if (widgetLoaded) return;
    widgetLoaded = true;

    if (placeholder) placeholder.style.display = 'none';
    if (widgetWrapper) widgetWrapper.style.display = 'block';

    // Bootstrap-Script schon vorhanden -> nur (neu) rendern
    if (window.Trustpilot) {
      renderWidgets();
      return;
    }

    const script = document.createElement('script');
    script.src = TRUSTPILOT_SCRIPT_URL;
    script.async = true;
    script.onload = renderWidgets;
    document.body.appendChild(script);
  }

  async function getTrustpilotService() {
    if (typeof UC_UI === 'undefined' || !UC_UI.getServicesBaseInfo) return null;

    try {
      const allServices = await UC_UI.getServicesBaseInfo();
      for (const s of allServices) {
        const name = (s.name || '').toLowerCase();
        if (name.includes('trustpilot')) return s;
      }
      return null;
    } catch (e) {
      console.warn('Trustpilot: UC_UI.getServicesBaseInfo() failed:', e);
      return null;
    }
  }

  function hasConsent(service) {
    return service && service.consent && service.consent.status === true;
  }

  async function checkConsent() {
    const service = await getTrustpilotService();
    if (!service) return false;
    return hasConsent(service);
  }

  async function acceptService() {
    const service = await getTrustpilotService();
    if (!service || typeof UC_UI.acceptService !== 'function') {
      loadTrustpilot();
      return;
    }

    UC_UI.acceptService(service.id);

    // Consents persistieren
    if (window.__ucCmp?.saveConsents) {
      await window.__ucCmp.saveConsents();
    }

    loadTrustpilot();
  }

  async function init() {
    if (await checkConsent()) {
      loadTrustpilot();
      return;
    }

    // Kein Consent: Skeleton entfernen, Placeholder-Inhalt anzeigen
    showPlaceholderContent();

    if (acceptBtn) {
      acceptBtn.addEventListener('click', acceptService);
    }

    window.addEventListener('UC_CONSENT', async function() {
      if (await checkConsent()) {
        loadTrustpilot();
      }
    });
  }

  if (typeof UC_UI !== 'undefined' && UC_UI.isInitialized && UC_UI.isInitialized()) {
    init();
  } else {
    window.addEventListener('UC_UI_INITIALIZED', init);
  }
})();
